module.exports = __webpack_public_path__ + "static/media/ABC-zainab16.5f00e26c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABC-zainab16.png
// module id = 157
// module chunks = 3